<template>
    
    <div class="loading-container">

        <div class="loading-tip-container"> 

            <img :src="images.info" class="loading-tip-icon" />

            温馨提示: 请在手机端打开
        </div>
    </div>
</template>

<script>

    import { toRefs, reactive } from "vue";

    import ImageInfo from "@/assets/info.png";

    export default {
        name: "Warning",
        setup() {

            const state = reactive({
                images: {
                    info: ImageInfo
                }
            });

            return {
                ...toRefs(state)
            }
        }
    };
</script>

<style lang="scss" scoped>

    .loading-container {

        background-color: #333333;
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;

        .loading-tip-container {

            background-color: white;
            width: 22rem;
            height: 11.67rem;
            border-radius: 1rem;
            position: fixed;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
            font-weight: 400;
            font-family: Source Han Sans CN;

            .loading-tip-icon {
                position: absolute;
                top: -12%;
            }
        }
    }
</style>